import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant'
import Tooltip from 'components/Tooltip'
import { Panel } from 'components/Panel'

import { shortDate } from 'helpers/formatters'

import { useStoreContext } from 'hooks/StoreContext'
import useScreenSize from 'hooks/useScreenSize'

import { color } from 'styles/colors'
import { screenSize, screenWidthBreakpoints } from 'styles/shared'

const HomeownerPanelHeaderNotification = () => {
  const dynamicScreenSize = useScreenSize()

  const { homeownerAlerts } = useStoreContext()

  if (!homeownerAlerts?.lastAlertedAt) {
    return null
  }

  const message = 'Customer last notified about an alert on'
  const date = shortDate(homeownerAlerts.lastAlertedAt)

  const content = (
    <KeyboardAccessible readOnly>
      <S.NotificationBubble>
        <S.Content>
          <S.Icon />
          <S.Message>{message}</S.Message>
          <S.Date>{date}</S.Date>
        </S.Content>
      </S.NotificationBubble>
    </KeyboardAccessible>
  )

  return (
    <S.Container>
      { dynamicScreenSize === 'large'
        ? (content)
        : (
          <Tooltip title={`${message} ${date}`} placement="top">
            {content}
          </Tooltip>
        )
      }
    </S.Container>
  )
}

const S = {
  Container: styled.div`
    margin: 0 10px;
  `,
  NotificationBubble: styled(Panel.Header)`
    background-color: ${color('paneBackground')};
    height: 28px;
    color: ${color('homeownerAlertText')};
    font-style: italic;
    border-radius: 10px;
    gap: 0;
  `,
  Content: styled.div`
    display: flex;
    align-items: center;
    margin: -1px -5px 0 -5px;
    gap: 4px;
  `,
  Icon: styled(NotificationImportantIcon)`
    margin-left: -3px;
    display: none;

    @media (max-width: ${screenWidthBreakpoints.homeownerAlertedShortVersionBreakpoint}px) {
      display: unset;
    }

    @media ${screenSize.small} {
      margin-right: -4px;
    }
  `,
  Message: styled.span`
    @media (max-width: ${screenWidthBreakpoints.homeownerAlertedShortVersionBreakpoint}px) {
      display: none;
    }
  `,
  Date: styled.span`
    @media ${screenSize.small} {
      display: none;
    }
  `
}

export default HomeownerPanelHeaderNotification
